import React from "react";

export default function Confirmation({
  travelRequests,
  referenceId,
  onNewRequest,
  onViewHistory
}) {
  return (
    <div className="page">
      <header className="app-header">
        <div className="header-inner">
          <div className="header-logo">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="#0F6E56" />
              <path
                d="M9 16L14 21L23 11"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>Travel Request Portal</span>
          </div>
        </div>
      </header>

      <main className="main-content">
        <div className="confirmation-card">
          <div className="confirmation-icon">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
              <circle cx="28" cy="28" r="28" fill="#E1F5EE" />
              <path
                d="M17 28L24 35L39 19"
                stroke="#0F6E56"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h2>Request submitted!</h2>
          <p className="confirmation-sub">
            Your travel request has been processed and you have been added to
            the appropriate security groups.
          </p>

          <div className="confirmation-ref">
            <span className="ref-label">Reference ID</span>
            <span className="ref-value">{referenceId}</span>
          </div>

          <div className="confirmation-summary">
            <h3>Summary</h3>
            {travelRequests.map((req, i) => (
              <div key={i} className="confirmation-trip">
                <span className="trip-flag">
                  {getFlagEmoji(req.countryCode)}
                </span>
                <div>
                  <strong>{req.country}</strong>
                  <span className="trip-dates">
                    {formatDate(req.startDate)} → {formatDate(req.endDate)}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="confirmation-info">
            <p>
              Access will be automatically revoked at the end of each travel
              period. You will receive an email when your access has been
              removed.
            </p>
          </div>

          <button
            className="btn-primary confirmation-btn"
            onClick={onNewRequest}
          >
            Submit another request
          </button>
          <button
            className="btn-secondary confirmation-btn"
            style={{ marginTop: 10 }}
            onClick={onViewHistory}
          >
            View my requests
          </button>
        </div>
      </main>
    </div>
  );
}

function getFlagEmoji(code) {
  if (!code) return "🌐";
  return code
    .toUpperCase()
    .split("")
    .map((c) => String.fromCodePoint(127397 + c.charCodeAt(0)))
    .join("");
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-");
  return `${m}/${d}/${y}`;
}
